import React, {useState} from 'react';
import {Chip, view} from '@sail/ui';
import {Container} from './common';

export const WithDropdown = () => {
  const [open, setOpen] = useState(false);
  return (
    <Container>
      <Chip
        label="Status"
        value="Succeeded"
        onDropdown={() => setOpen(!open)}
        onClose={() => {
          // eslint-disable-next-line no-alert
          alert('Close function triggered');
        }}
      />
      {open && (
        <view.div
          css={{
            font: 'caption',
            borderRadius: 'medium',
            background: 'container',
            margin: 'small',
            padding: 'medium',
            color: 'secondary',
          }}
        >
          Dropdown contents
        </view.div>
      )}
    </Container>
  );
};
